import React from "react";
import DiscordIcon from "./icons/DiscordIcon";
import { ChatBubbleLeftRightIcon } from "@heroicons/react/24/outline";

const FeedbackBanner: React.FC = () => {
  return (
    <div className="mt-6 mb-8 rounded-[8px] overflow-hidden bg-white dark:bg-[#1D1D1D] border border-gray-200 dark:border-[#292929] shadow-sm">
      <div className="flex flex-col sm:flex-row items-center justify-between px-8 py-5">
        <div className="flex items-center mb-4 sm:mb-0">
          <div className="flex items-center justify-center rounded-full bg-gray-100 dark:bg-purple-900/30 w-10 h-10 mr-4">
            <ChatBubbleLeftRightIcon className="w-5 h-5 text-gray-500 dark:text-purple-400" />
          </div>
          <div>
            <h3 className="text-base font-medium text-gray-900 dark:text-white">Send us your feedback</h3>
            <p className="text-sm text-gray-400 dark:text-gray-400">We're still in beta, please tell us if we get something wrong.</p>
          </div>
        </div>
        <a 
          href="https://discord.gg/CtksNa3Dfj" 
          target="_blank" 
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center px-5 py-2.5 rounded-lg whitespace-nowrap bg-purple-600 hover:bg-purple-700 transition-colors duration-300 font-medium text-sm"
          style={{ color: 'white' }}
        >
          <DiscordIcon className="w-5 h-5 mr-2" style={{ color: 'white' }} />
          <span style={{ color: 'white' }}>Join our Discord</span>
        </a>
      </div>
    </div>
  );
};

export default FeedbackBanner; 